import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./paths"; // generated by openapi-typescript

// Create the fetch client
// In tests, use full URL to hit the real API
// In dev/prod, use relative URLs (proxied by Vite dev server or hosting provider)
const fetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.VITEST 
    ? "https://sanctions-api.sacha-29f.workers.dev" 
    : undefined,
});

// Add authentication interceptor
fetchClient.use({
  onRequest: async ({ request }) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }
    return request;
  },
  onResponse: async ({ response }) => {
    // Handle token expiration for authenticated requests
    if (response.status === 401) {
      localStorage.removeItem('auth_token');

      // Only redirect if not already on an auth page
      if (!window.location.pathname.startsWith('/auth')) {
        window.location.href = '/auth';
      }
    }

    return response;
  },
});

// Create the React Query client
export const $api = createClient(fetchClient);

// Export the fetch client for direct use (for auth flows that need direct access)
export { fetchClient };